import api from '../../services/api';
import { useState, useEffect } from "react";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';
import PersonOutlineIcon from '@mui/icons-material/PersonOutline';
import Pagination from '@mui/material/Pagination';
import Box from '@mui/material/Box';
import PageContainer from '../../common/components/PageContainer';
import PageHeader from '../../common/components/PageHeader';
import EntityCardGrid from '../../common/components/EntityCardGrid';
import EntityCard from '../../common/components/EntityCard';
import usePermissoes from '../../common/hooks/usePermissoes';
import Permissoes from '../../common/permissoes';

function Funcionario() {
    const { hasPermission } = usePermissoes();
    const [textoPesquisa, setTextoPesquisa] = useState("");
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get(`/funcionario/pesquisa?texto=${textoPesquisa}&page=${page - 1}`);
                setData(response.data.content);
                setTotalPages(response.data.page.totalPages);
            } catch (error) {
                console.error("Erro ao buscar dados dos Funcionarios:", error);
            }
        }
        fetchData();
    }, [page, textoPesquisa]);

    const handleChange = (event, value) => {
        setPage(value);
    };

    return (
        <PageContainer>
            <PageHeader
                title="Funcionários"
                searchValue={textoPesquisa}
                onSearchChange={(e) => {
                    setPage(1);
                    setTextoPesquisa(e.target.value);
                }}
                actionLabel={hasPermission(Permissoes.FUNCIONARIO_CADASTRO) ? "Adicionar Funcionário" : undefined}
                actionIcon={<AddCircleOutlineIcon />}
                actionTo="/funcionario/cadastro"
            />

            <EntityCardGrid
                items={data}
                keyExtractor={(funcionario) => funcionario.id}
                emptyMessage="Nenhum funcionário encontrado."
                renderItem={(funcionario) => (
                    <EntityCard
                        to={`/funcionario/${funcionario.id}`}
                        image={funcionario.foto ? `data:image/jpeg;base64,${funcionario.foto}` : null}
                        icon={<PersonOutlineIcon fontSize="inherit" />}
                        title={funcionario.nome}
                        subtitle={funcionario.cargo}
                    />
                )}
            />

            {totalPages > 1 && (
                <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                    <Pagination count={totalPages} page={page} onChange={handleChange} color="primary" />
                </Box>
            )}
        </PageContainer>
    );
}

export default Funcionario;
